import React, { useEffect, useRef } from 'react';
import { Box } from '@chakra-ui/react';

interface ITheme {
  color?: string;
  margin?: string;
  lineHeight?: number;
  lines?: number;
  height?: number;
  fontSize?: number;
}

export interface IProps {
  children: React.ReactNode;
  theme?: ITheme;
  overflowedHandler?: (isOverflowed: boolean) => void;
}

export const OverflowedText = ({ children, theme, overflowedHandler }: IProps) => {
  const agentRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (overflowedHandler) {
      const isOverflowed = agentRef?.current?.clientHeight
        ? agentRef?.current?.scrollHeight / (theme?.lineHeight || 16) > (theme?.lines || 2)
        : false;
      overflowedHandler(isOverflowed);
    }
  }, [overflowedHandler, theme?.lineHeight, theme?.lines]);

  return (
    <Box
      noOfLines={theme.lines || 2}
      fontSize={theme.fontSize || 'sm'}
      lineHeight={theme.lineHeight || '1rem'}
      color={theme.color}
      margin={theme.margin}
      height={theme.height}
      data-selector="overflowed-text"
      id="overflowedTextContainer"
      ref={agentRef}
    >
      {children}
    </Box>
  );
};
